import makeRequest from "./makeRequest";
import { reviewMapper } from "../../mappers/review";
import getRuntimeConstants from "../runtimeConstants";

export default async function getReviews({ offset, filter } = {}) {
  const {
    webContext: { browseLanguage, storeId },
    product: { id },
    ratingsApiPath,
    ratingsApiTimeout,
  } = getRuntimeConstants();

  let url = `${ratingsApiPath}/${id}`;
  const params = {
    offset,
    limit: 10,
    include: "Products",
    store: storeId,
    lang: browseLanguage,
    filteredStats: "reviews",
    sort: "SubmissionTime:desc",
  };

  // Handle multiple filters by appending to URL manually
  // SDK serializes arrays as filter[]=X which the API doesn't support
  if (Array.isArray(filter)) {
    if (filter.length > 0) {
      const filterQuery = filter
        .map((f) => `filter=${encodeURIComponent(f)}`)
        .join("&");
      url = `${url}?${filterQuery}`;
    }
  } else if (filter !== undefined && filter !== null) {
    params.filter = filter;
  }

  const mapData = ({ results, totalResults, reviewsSummary, includes }) => {
    const productStats =
      includes?.products?.[String(id)]?.filteredReviewStatistics;
    return {
      results: results.map((result) => reviewMapper(result)),
      totalResults,
      reviewsSummary: reviewsSummary ?? null,
      ratingsStatistics: productStats ?? null,
    };
  };

  const handleErrorReturnValue = (error) => {
    throw error;
  };

  return makeRequest({
    url,
    params,
    timeout: ratingsApiTimeout,
    requestType: "RATINGS_API",
    apiName: "Ratings",
    caller: "Ratings",
    mapData,
    handleErrorReturnValue,
  });
}
